import ScamflagLogo from './ScamflagLogo';

type Props = {
  className?: string;
  iconClassName?: string;
  wordmarkClassName?: string;
};

export default function ScamflagWordmark({
  className = '',
  iconClassName = 'w-9 h-9',
  wordmarkClassName = 'text-xl',
}: Props) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <ScamflagLogo className={iconClassName} />
      <span
        className={`font-display font-bold uppercase tracking-tight leading-none ${wordmarkClassName}`}
        style={{ fontFamily: '"Space Grotesk", Inter, system-ui, sans-serif' }}
      >
        <span className="text-flag-500">SCAM</span>
        <span className="text-white">FLAG</span>
      </span>
    </div>
  );
}
